import _ from 'underscore';

const ADGROUP_PAGE_SIZE = 10;

function transformAdgroupData(data, optionalAdGroupSelect = []) {
  if (!_.isArray(data)) {
    return [];
  }

  const adgroupData = data.map(item => (_.extend(
    _.pick(item, 'Id', 'Name', 'Status', 'Language', ...optionalAdGroupSelect),
    {
      name: item.Name,
      status: item.Status,
      campaignName: item.Campaign && item.Campaign.Name,
      campaignId: item.Campaign && item.Campaign.Id,
      parentId: item.Campaign && item.Campaign.Id,
      Campaign: item.Campaign,
    }
  )));

  return {
    totalCount: data.totalCount,
    items: adgroupData,
  };
}

export function getAdgroupData({
  query = '',
  pageNumber = 0,
  pageSize = ADGROUP_PAGE_SIZE,
  campaignId = null,
  optionalAdgroupFilter = '',
  optionalAdGroupSelect = [],
  optionalAdGroupExpand = [],
}, jsdata, edmCampaign) {
  const signleQuoteTerminatedQuery = query.replace('\'', '\'\'');

  const filter = _.compact([
    optionalAdgroupFilter,
    query && `contains(Name, '${signleQuoteTerminatedQuery}')`,
  ]).join(' and ');

  const $expand = [
    'Id',
    'Name',
    'CampaignType',
    'CampaignSubType',
  ].concat(optionalAdGroupExpand);

  const $select = [
    'Id',
    'Name',
    'Status',
    'Language',
  ].concat(optionalAdGroupSelect).join(', ');

  const formatQuery = {
    $expand: `Campaign($select=${$expand.join(',')})`,
    $select,
    $orderby: 'Name asc',
    $skip: pageNumber * pageSize,
    $top: pageSize,
    $count: true,
  };

  if (campaignId) {
    _.extend(formatQuery, {
      entitySet: edmCampaign
        .currentAccount
        .Campaigns
        .$withKey(Number(campaignId))
        .AdGroups
        .toJSON(),
    });
  }

  if (filter) {
    formatQuery.$filter = filter;
  }

  return jsdata.AdGroup.findAll({
    query: formatQuery,
  }).then(data => transformAdgroupData(data, optionalAdGroupSelect));
}
